import { BusinessContext } from '@types';
import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchSonarObjectBusinessContextRequest = {
	sonarObjectId: number;
	context: Partial<BusinessContext>;
};

export const patchSonarObjectBusinessContext = createPatchEndpoint<PatchSonarObjectBusinessContextRequest>(
	({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/context`,
	{
		requestTransform: ({ context }) => context
	}
);
